import React from 'react';
import PropTypes from 'prop-types';
import { reportStates, stateColors, stateTextColors } from '../../../constants/reports';
import { ListItem } from 'material-ui';
import { blue100, blue300, grey300 } from 'material-ui/styles/colors';
import withTranslation from '../../../hoc/withTranslation';

const style = {
    dialogBlock: {
        whiteSpace: 'pre-wrap',
        backgroundColor: grey300,
        borderRadius: '24px',
        padding: '10px 15px',
        maxWidth: '75%',
        width: 'auto',
        margin: '0.25em 0',
        display: 'inline-block',
    },
    dialogBlockMine: {
        backgroundColor: blue300,
    },
    dialogBlockAdmin: {
        backgroundColor: blue100,
    },
    dialogBlockText: {
        direction: 'ltr',
        maxWidth: '100%',
        width: 'auto',
        margin: 0,
        textAlign: 'left',
        display: 'block',
    },
    dialogBlockImg: {
        maxWidth: '100%',
        maxHeight: '24em',
        borderRadius: '24px',
        width: 'auto',
    },
    rightText: {
        textAlign: 'right',
    },
    username: {
        display: 'block',
        position: 'absolute',
        top: '-0.75em',
        left: '25px',
        color: 'rgba(0, 0, 0, 0.54)',
    },
    date: {
        fontSize: '0.75em',
        paddingLeft: '10px',
        paddingRight: '10px',
        marginTop: '-3px',
    }
};

class ReportTalkMessage extends React.Component {
    static propTypes = {
        item: PropTypes.object.isRequired,
        t: PropTypes.func.isRequired,
        authUsername: PropTypes.string,
    };

    render() {
        const {
            item,
            t,
            authUsername,
        } = this.props;
        const mine = !item.user && item.admin.username === authUsername;
        const withText = item.response && item.response.trim() !== '';
        const withImg = item.type === 'message' && item.picture;
        let textRootStyle = style.dialogBlock;
        let imgRootStyle = {
            ...style.dialogBlock,
            backgroundColor: 'transparent',
            padding: 0,
        };
        let textStyle = style.dialogBlockText;

        if (item.type === 'status') {
            textRootStyle = {
                ...textRootStyle,
                backgroundColor: stateColors[reportStates.indexOf(item.response)],
            };
            textStyle = {
                ...textStyle,
                color: stateTextColors[reportStates.indexOf(item.response)],
            };
        } else if (mine) {
            textRootStyle = { ...textRootStyle, ...style.dialogBlockMine };
            textStyle = {
                ...textStyle,
                width: '100%',
            };
        } else if (!item.user) {
            textRootStyle = { ...textRootStyle, ...style.dialogBlockAdmin };
        }
        const date = new Date(item.created_at * 1000);
        const username = (
            item.user
                ? item.user.username
                : item.admin.username
        );
        const dateText = date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
        return (
            <div>
                {withText && (
                    <ListItem
                        style={{
                            ...(mine ? { direction: 'rtl' } : {}),
                            ...(withImg && withText ? { padding: '20px 16px 0' } : {}),
                        }}
                        key={dateText}
                        primaryText={(
                            <div style={textRootStyle}>
                                <p style={{...style.username, ...(mine ? { left: 'unset', right: '25px'} : {})}}>
                                    {username}
                                </p>
                                <p style={textStyle}>
                                    {item.type === 'status'
                                        && t('module.report.state.' + item.response)}
                                    {item.type === 'message' && item.response}
                                </p>
                            </div>
                        )}
                        secondaryText={!withImg
                            ? (
                                <div style={{...style.date, ...(mine ? style.rightText : {})}}>
                                    {dateText}
                                </div>
                            )
                            : undefined
                        }
                        disabled
                    />
                )}
                {withImg && (
                    <ListItem
                        style={{
                            ...(mine ? { direction: 'rtl' } : {}),
                            ...(withImg && withText ? { paddingTop: '0' } : {}),
                        }}
                        key={dateText}
                        primaryText={(
                            <div style={imgRootStyle}>
                                {!withText && (
                                    <p style={{...style.username, ...(mine ? { left: 'unset', right: '25px'} : {})}}>
                                        {username}
                                    </p>
                                )}
                                <img style={style.dialogBlockImg} src={item.picture} alt="img" />
                            </div>
                        )}
                        secondaryText={(
                            <div style={{...style.date, ...(mine ? style.rightText : {})}}>
                                {dateText}
                            </div>
                        )}
                        disabled
                    />
                )}
            </div>
        );
    }
}

export default withTranslation(ReportTalkMessage);



// WEBPACK FOOTER //
// src/components/report/ReportTalk/ReportTalkMessage.js